// FLAGS: none
// Forwards each Core Web Vitals measurement to App Insights as a metric, scaling CLS to an integer.
// Carries no user data of its own; the telemetry initializer still appends the current path to the name.
import { Metric } from "web-vitals";
import { appInsights } from "./AppInsights";

export default function webVitalsReporter(metric: Metric) {
  appInsights.trackMetric(
    {
      name: metric.name,
      average: Math.round(
        metric.name === "CLS" ? metric.value * 1000 : metric.value,
      ),
    },
    { rating: metric.rating },
  );
}
